// extracted by mini-css-extract-plugin
export default {"fields":"role_fields__IDu-S"};